<template>
  <div>
    <!-- 头部搜索分页盒子开始 -->
    <div
      :class="header == true ? 'search-box' : 'search-box1'"
      :style="{ width: $store.getters.contractNum == 2 ? '100%' : '' }"
    >
      <div class="slide">
        <div style="margin-top: 10px; margin-left: 10px">
          <span class="all_text" @click="cleanUpEvt">All</span>
          <el-input
            v-model="checkInput"
            style="width: 120px"
            size="mini"
            @focus="searchLabel1Evt"
            placeholder="标签查询"
            clearable
            @clear="clearEvt1"
          ></el-input>
          <el-input
            v-model="frontOrderInput"
            style="width: 120px"
            @change="frontOrderEvt"
            size="mini"
            placeholder="ID查询"
            clearable
            @clear="clearEvt2"
          ></el-input>
          <el-input
            v-model="authorInput"
            style="width: 120px"
            size="mini"
            @change="authorEvt"
            placeholder="选择作者"
            clearable
            @clear="clearEvt3"
          ></el-input>
          <el-date-picker
            v-model="value2"
            style="width: 240px"
            type="daterange"
            @change="timeEvt"
            :picker-options="pickerOptions"
            size="mini"
            format="yyyy-MM-dd"
            value-format="yyyyMMdd"
            range-separator=""
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            align="right"
          >
          </el-date-picker>
        </div>
        <div :style="{ display: $store.getters.process == 3 ? '' : 'none' }" class="caoz">
          <el-input
            v-model="operateLabelInput"
            style="width: 120px; margin-left: 10px"
            size="mini"
            @focus="searchLabelEvt"
            placeholder="标签操作"
          ></el-input>
          <el-checkbox-group
            v-model="radio"
            @change="checkboxEvt"
            v-if="operateNum.show == true"
          >
            <el-checkbox style="margin-right: 70px" label="1"
              >全部{{ operateNum.all }}</el-checkbox
            >
            <el-checkbox label="2">未审阅{{ operateNum.not_review }}</el-checkbox>
            <el-checkbox label="3">属于{{ operateNum.belong }}</el-checkbox>
            <el-checkbox label="4">不属于{{ operateNum.not_belong }}</el-checkbox>
          </el-checkbox-group>
        </div>
        <div :class="header == true ? 'block' : 'block1'">
          <div class="pagination_box">
            <el-input
              v-model="paginationInput"
              style="width: 50px"
              size="mini"
              @change="limitEvt"
              placeholder="请输入本页显示"
            ></el-input>
            <el-pagination
              @current-change="handleCurrentChange"
              :current-page.sync="currentPage1"
              :page-size="paginationInput - 0"
              layout="prev, pager, next, jumper"
              :total="total"
            >
            </el-pagination>
          </div>

          <div class="all-box">
            <el-button
              type="primary"
              size="mini"
              @click="selectAllEvt"
              style="width: 78px"
              :style="{ backgroundColor: selectAllBgColor }"
              >{{ selectAllText }}</el-button
            >
            <span> &nbsp; 已选中 </span>
            <span>：{{ selectArr.length }} </span>
          </div>
          <div class="changing-box">
            <!-- <el-button type="primary" @click="uploadEvt" size="mini">上传素材</el-button> -->
            <el-button type="info" @click="delete_Pop" size="mini">删除</el-button>

            <el-dropdown :hide-on-click="false" @command="sortEvt">
              <span class="el-dropdown-link">
                {{ sortName }}<i class="el-icon-arrow-down el-icon--right"></i>
              </span>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item command="9" :disabled="sort == 9 ? true : false"
                  >收藏最多</el-dropdown-item
                >
                <el-dropdown-item command="7" :disabled="sort == 7 ? true : false"
                  >下载次数最多</el-dropdown-item
                >
                <el-dropdown-item command="1" :disabled="sort == 1 ? true : false"
                  >上传时间-升序</el-dropdown-item
                >
                <el-dropdown-item command="2" :disabled="sort == 2 ? true : false"
                  >上传时间-降序</el-dropdown-item
                >
                <el-dropdown-item command="3" :disabled="sort == 3 ? true : false"
                  >文件大小-升序</el-dropdown-item
                >
                <el-dropdown-item command="4" :disabled="sort == 4 ? true : false"
                  >文件大小-降序</el-dropdown-item
                >
                <el-dropdown-item command="5" :disabled="sort == 5 ? true : false"
                  >文件尺寸-升序</el-dropdown-item
                >
                <el-dropdown-item command="6" :disabled="sort == 6 ? true : false"
                  >文件尺寸-降序</el-dropdown-item
                >
                <el-dropdown-item command="8" :disabled="sort == 8 ? true : false"
                  >点击查看次数最多</el-dropdown-item
                >
              </el-dropdown-menu>
            </el-dropdown>

            <img
              v-if="changing == 1"
              style="width: 20px; height: 20px; position: relative; top: 5px"
              src="../../../img/1.png"
            />
            <img
              v-else
              style="
                width: 20px;
                height: 20px;
                cursor: pointer;
                position: relative;
                top: 5px;
              "
              @click="changingEvt(1)"
              src="../../../img/2.png"
            />
            <img
              v-if="changing == 2"
              style="width: 20px; height: 20px; position: relative; top: 5px"
              src="../../../img/4.png"
            />
            <img
              v-else
              style="
                width: 20px;
                height: 20px;
                cursor: pointer;
                position: relative;
                top: 5px;
              "
              @click="changingEvt(2)"
              src="../../../img/3.png"
            />
            <img
              v-if="changing == 3"
              style="width: 20px; height: 20px; position: relative; top: 5px"
              src="../../../img/5.png"
            />
            <img
              v-else
              style="
                width: 20px;
                height: 20px;
                cursor: pointer;
                position: relative;
                top: 5px;
              "
              @click="changingEvt(3)"
              src="../../../img/6.png"
            />
          </div>
        </div>
      </div>
    </div>
    <!-- 头部搜索分页结束 -->

    <!-- 图片盒子开始 -->
    <el-scrollbar>
      <div
        v-loading="loading"
        v-if="changing !== 3"
        class="img-box"
        :style="{ width: $store.getters.contractNum == 2 ? '100%' : '' }"
      >
        <div class="flex-images" @scroll="imgScrollEvt">
          <div
            class="item"
            v-for="(e, index) in imgArr"
            :key="index"
            :data-w="changing == 1 ? '400' : '400'"
            :data-h="changing == 1 ? '280' : '280'"
            @mousemove="mousemoveEvt(e)"
            @mouseout="mouseoutEvt"
            @click.stop="imgEvt(e)"
            @contextmenu.prevent="rightClickEvt"
          >
            <img :src="e.thumb" />

            <div class="select" :style="{ display: e.select == true ? 'block' : 'none' }">
              <i class="el-icon-check"></i>
            </div>
            <el-popover
              :style="{ display: e.select == true ? 'block' : 'none' }"
              class="operation_box"
              placement="right-start"
              width="230"
              trigger="manual"
              v-model="e.leftSelect"
            >
              <div class="operation_center">
                <div class="center_box" v-for="res in operationArr" :key="res.id">
                  <span>{{ res.title }}</span>
                  <el-checkbox-group
                    v-model="res.selectArr"
                    @change="checkbox1Evt(res)"
                    v-for="j in res.children"
                    :key="j.id"
                  >
                    <el-checkbox :label="j.id">{{ j.title }}</el-checkbox>
                  </el-checkbox-group>
                </div>
                <div class="btn_box">
                  <el-button size="mini" ref="coverCancel" @click="cancelEvt(e)"
                    >取消</el-button
                  >
                  <el-button type="primary" @click="changeImgEvt(e)" size="mini"
                    >确定</el-button
                  >
                </div>
              </div>
              <el-button
                slot="reference"
                @click.stop="leftSelectEvt(e)"
                icon="el-icon-s-operation"
              ></el-button>
            </el-popover>

            <span class="id_text" v-if="e.source_id == mousemoveId"
              >id:{{ e.source_id }}</span
            >

            <div class="bottom_text">
              <div></div>
              <div>
                <!-- <span v-if="favorite !==9&&review !==8">下载次数:{{ e.download_num }}</span>
                            <span v-else-if="review ==8">查看次数:{{ e.review }}</span>
                            <span v-else-if="favorite ==9">收藏次数:{{ e.favorite }}</span> -->
                <b v-if="operateNum.show == true"></b>
                <i
                  v-if="operateNum.show == true && e.status == 0"
                  style="background-color: green"
                ></i>
                <i
                  v-else-if="operateNum.show == true && e.status == 1"
                  style="background-color: #f00"
                ></i>
                <i v-else-if="operateNum.show == true && e.status == 3"></i>
              </div>
            </div>
          </div>
        </div>
      </div>
    </el-scrollbar>
    <!-- 图片盒子结束 -->
    <!-- 空格弹窗开始 -->
    <el-dialog
      title=""
      :visible.sync="dialogVisible"
      custom-class="spaceDialog"
      width="90%"
      :show-close="false"
      :before-close="handleClose"
      @open="spaceDialogEvt"
      @close="spaceCloseDiaEvt"
    >
      <div class="spaceDialog_box">
        <!-- 图片 -->
        <div :class="changingImg == false ? 'spaceDialogImg' : 'spaceDialogImg1'">
          <div class="changing_box">
            <el-switch
              v-model="changingImg"
              active-color="#409EFF"
              inactive-color="#999"
              :change="changingImgEvt"
            >
            </el-switch>
          </div>
          <!-- :data-w="changingImg==true?spaceImgInfo.w:'500'" :data-h="changingImg==true? spaceImgInfo.h :300" -->
          <img
            :style="{
              width: changingImg == true ? spaceWidth : frontSpaceWidth,
              height: changingImg == true ? spaceHeight : frontSpaceHeight,
            }"
            :src="spaceSrc"
            alt=""
          />
          <div class="arrow_box">
            <div class="left" @click="arrowLeftEvt"></div>
            <div class="right" @click="arrowRightEvt"></div>
          </div>
        </div>
        <div class="info_box">
          <span>ID：{{ spaceImgInfo.id }}</span>
          <span>作者：{{ spaceImgInfo.author }}</span>
          <span> 尺寸：{{ spaceImgInfo.w }}*{{ spaceImgInfo.h }}</span
          ><span>时间：{{ spaceImgInfo.create_time }}</span>
        </div>
        <!-- 标签属于 -->
        <div v-if="operateLabelInput !== ''" class="belong_box">
          <span>
            当前操作标签 &nbsp; <b>{{ operateLabelInput }}</b>
          </span>
          <span @click="belongEvt">
            <i></i
            ><strong style="background-color: green" v-if="belongShow == 0"></strong>
            属于</span
          >
          <span @click="noBelongEvt">
            <i></i>
            <strong v-if="belongShow == 1" style="background-color: #f00"></strong>
            <strong v-else-if="belongShow == 3"></strong>
            不属于</span
          >
        </div>
        <!-- 标签 -->
        <div :class="changingImg == false ? 'spaceLabel_box' : 'spaceLabel_box1'">
          <div class="space" style="float: left; margin-left: 20px">
            <div class="check">
              <div v-for="item in spaceLabelArr" :key="item.id">
                <p :style="{ color: item.one == true ? '#409EFF' : '#595959' }">
                  {{ item.title }}
                </p>
                <div
                  class="checkbox"
                  v-for="e in item.children"
                  :key="e.id"
                  @click.stop="labelEvt(e)"
                >
                  <i @click.stop="color1Evt(e)"></i>
                  <b @click.stop="color1Evt(e)" v-if="e.status == 3"></b>
                  <b
                    @click.stop="color1Evt(e)"
                    v-else-if="e.status == 0"
                    style="background-color: green"
                  ></b>
                  <b
                    @click.stop="color1Evt(e)"
                    v-else-if="e.status == 1"
                    style="background-color: rgb(249, 157, 157)"
                  ></b>
                  <b
                    @click.stop="color1Evt(e)"
                    v-else-if="e.status == 2"
                    style="background-color: #d1d1d1"
                  ></b>
                  <span
                    :style="{
                      color:
                        e.status == 0
                          ? '#000'
                          : e.status == 1
                          ? '#d0d0d0'
                          : e.status == 3
                          ? '#000'
                          : '',
                      'font-weight': e.status == 0 ? '400' : '',
                    }"
                    >{{ e.title }}
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div
          :style="{ display: changingImg == false ? 'block' : 'none' }"
          class="allNo_box"
        >
          <button @click="allNoEvt">剩余全否</button>
        </div>
        <div class="num-box">
          <span>{{ spaceDialogNum }}</span>
          /
          <span>{{ selectArr.length }}</span>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="cancellationEvt">取 消</el-button>
        <el-button size="small" type="primary" @click="submitSpaceLabelEvt"
          >确 定</el-button
        >
      </span>
    </el-dialog>
    <!-- 空格弹窗结束 -->

    <!-- 标签操作弹窗开始 -->
    <el-dialog
      title=""
      :visible.sync="searchLabelDialog"
      width="51%"
      custom-class="searchLabel"
      :show-close="false"
      @open="searchDialogEvt"
    >
      <div style="width: 90%; height: 100%">
        <div class="space" style="float: left; margin-left: 20px">
          <div class="check">
            <div v-for="item in labelArr" :key="item.id">
              <p>{{ item.title }}</p>
              <div
                class="checkbox"
                v-for="e in item.children"
                :key="e.id"
                @click="labelSearchEvt(e)"
              >
                <i></i>
                <b v-if="e.status == 3"></b>
                <b v-else-if="e.status == 0" style="background-color: green"></b>
                <b v-else-if="e.status == 1" style="background-color: #f00"></b>
                <b v-else-if="e.status == 2" style="background-color: #999"></b>
                <span
                  class="space_title"
                  :style="{
                    backgroundColor: e.finish == 1 ? '#e5e5e5' : 'none',
                    padding: '4px',
                  }"
                  >{{ e.title }}</span
                >
              </div>
            </div>
          </div>
        </div>
      </div>
    </el-dialog>
    <!-- 标签操作弹窗结束 -->
    <SearchLabel
      :searchFor="searchFor"
      @cancel="cancel"
      :process="process"
      @revise="revise"
      :type="type"
      @reviseText="reviseText"
      :author="authorInput"
      :time="value2"
      :frontOrder="frontOrderInput"
      :operateLabelInput="operateLabelInput"
      :labelId="labelId"
      :checkInput="checkInput"
    />

    <!-- 右键弹窗开始 -->
    <el-dialog
      title=""
      :visible.sync="rightLabelDialog"
      width="51%"
      custom-class="searchLabel"
      :show-close="false"
      @close="closeEvt"
      @open="rightDialogEvt"
    >
      <div style="width: 90%; height: 580px">
        <div class="space" style="float: left; margin-left: 20px">
          <div class="check">
            <div v-for="item in labelArr" :key="item.id">
              <p :style="{ color: item.one == true ? '#409EFF' : '#595959' }">
                {{ item.title }}
              </p>
              <div
                class="checkbox"
                v-for="e in item.children"
                :key="e.id"
                @click.stop="searchLabEvt(e)"
              >
                <i @click.stop="colorEvt(e)"></i>
                <b @click.stop="colorEvt(e)" v-if="e.status == 3"></b>
                <b
                  @click.stop="colorEvt(e)"
                  v-else-if="e.status == 0"
                  style="background-color: green"
                ></b>
                <b
                  @click.stop="colorEvt(e)"
                  v-else-if="e.status == 1"
                  style="background-color: rgb(249, 157, 157)"
                ></b>
                <b
                  @click.stop="colorEvt(e)"
                  v-else-if="e.status == 2"
                  style="background-color: #d1d1d1"
                ></b>
                <span
                  :style="{
                    color:
                      e.status == 0
                        ? '#333'
                        : e.status == 1
                        ? '#d0d0d0'
                        : e.status == 2
                        ? '#d0d0d0'
                        : e.status == 3
                        ? '#000'
                        : '',
                    'font-weight': e.status == 0 ? '400' : '',
                  }"
                  >{{ e.title }}
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="rightSearch">已选中:{{ selectArr.length }}</div>
      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="rightLabelDialog = false">取 消</el-button>
        <el-button size="small" type="primary" @click="submitRightLabelEvt"
          >确 定</el-button
        >
      </span>
    </el-dialog>
    <!-- 右键弹窗结束 -->

    <el-dialog
      title="提示"
      :visible.sync="deleteVisible"
      width="30%"
      :before-close="handleClose"
    >
      <span style="font-size: 14px">
        {{
          $store.getters.process == 4
            ? "此操作将文件永久删除, 是否继续?"
            : "此操作将文件放进回收站, 是否继续?"
        }}</span
      >
      <span slot="footer" class="dialog-footer">
        <el-button @click="deleteVisible = false">取 消</el-button>
        <el-button type="primary" @click="deleteEvt">确 定</el-button>
      </span>
    </el-dialog>

    <!-- 文件上传开始 -->
    <el-dialog
      title="上传参考"
      :visible.sync="uploadVisible"
      width="90%"
      :close-on-press-escape="true"
      :destroy-on-close="true"
    >
      <Upload />

      <span slot="footer" class="dialog-footer"> </span>
    </el-dialog>
    <!-- 文件上传结束 -->
    <List v-if="changing == 3" />
  </div>
</template>

<script>
import "../../../backHome/js/flex-images";
import {
  getLabelApi,
  // getPSImgLabelApi,
  spaceDataSubmitApi,
  showApi,
} from "../../../apis/ces/a";
import {
  PSImgApi,
  getPSLabelApi,
  changePSImgApi,
  getPSImgLabelApi,
  psLabelApi,
  rightPsLabelApi,
  singPSleLabelApi,
  PSmaterialApi,
  deleteApi,

} from "../../../apis/ps";
import SearchLabel from "./compontents/PS_Sky.vue";
import List from "@/components/list.vue";
import Upload from "../../../upload/index.vue";
const delay = (function () {
  let timer = 0;
  return function (callback, ms) {
    clearTimeout(timer);
    timer = setTimeout(callback, ms);
  };
})();
export default {
  components: {
    SearchLabel,
    Upload,
    List,
  },
  data() {
    return {
      sortName: "排序方式",
      uploadVisible: false,
      //查询数据
      checkInput: "",
      checkInputIs_tag: [],
      checkInputNot_tag: [],
      //序列前后数据
      behindOrderInput: "",
      frontOrderInput: "",
      //选择作者数据
      authorInput: "",
      //分页输入框数据
      paginationInput: null,
      //分页总数据
      total: null,
      //标签操作输入框数据
      operateLabelInput: "",
      //标签id
      labelId: "",
      //控制标签1 or 2请求
      labelAjax: false,
      pickerOptions: {
        shortcuts: [
          {
            text: "今天",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "本周",
            onClick(picker) {
              const current = new Date();
              let nowDayOfWeek = current.getDay();
              if (nowDayOfWeek === 0) nowDayOfWeek = 7;
              const dayNum = 1 * 24 * 60 * 60 * 1000;
              const firstDate = new Date(current.valueOf() - (nowDayOfWeek - 1) * dayNum);
              const lastDate = new Date(new Date(firstDate).valueOf() + 6 * dayNum);
              picker.$emit("pick", [firstDate, lastDate]);
            },
          },
          {
            text: "当月",
            onClick(picker) {
              const date = new Date();
              const year = date.getFullYear();
              const month = date.getMonth();
              let thisMonthStartDate = new Date(year, month, 1);
              let thisMonthEndDate = new Date(year, month + 1, 0);
              picker.$emit("pick", [thisMonthStartDate, thisMonthEndDate]);
            },
          },
          {
            text: "当年",
            onClick(picker) {
              var tYear = new Date().getFullYear();
              var startTime = new Date(tYear, 0, 1); //当前年第一天
              var endTime = new Date(tYear, 11, 31); //当前年最后一天
              picker.$emit("pick", [startTime, endTime]);
            },
          },
          {
            text: "昨天",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 1);
              picker.$emit("pick", [start, start]);
            },
          },
          {
            text: "上周",
            onClick(picker) {
              const current = new Date(new Date().getTime() - 60 * 60 * 24 * 7 * 1000);
              let nowDayOfWeek = current.getDay();
              let diffToMonday =
                current.getDate() - nowDayOfWeek + (nowDayOfWeek === 0 ? -6 : 1);
              const firstDate = new Date(current.setDate(diffToMonday));
              const lastDate = new Date(current.setDate(diffToMonday + 6));
              picker.$emit("pick", [firstDate, lastDate]);
            },
          },
          {
            text: "上月",
            onClick(picker) {
              var now = new Date();
              var fd = new Date(now.getFullYear(), now.getMonth() - 1, 1);
              var ed = new Date(now.getFullYear(), now.getMonth(), 0);
              picker.$emit("pick", [fd, ed]);
            },
          },
          {
            text: "去年",
            onClick(picker) {
              var tYear = new Date().getFullYear() - 1;
              var startTime = new Date(tYear, 0, 1);
              var endTime = new Date(tYear, 11, 31); //当前年最后一天
              picker.$emit("pick", [startTime, endTime]);
            },
          },
        ],
      },
      value2: "",
      input: "",
      //标签操作数据
      operateNum: {},
      // 滚动前，滚动条距文档顶部的距离
      oldScrollTop: 0,
      header: true,
      // 分页数据
      currentPage1: 1,
      //图片数据
      imgArr: [],
      // shift 案件数据
      shift: false,
      shiftFirst: false,
      //已选中图片数据
      selectArr: [],
      //空格弹窗
      dialogVisible: false,
      //空格弹窗标签数据
      spaceLabelArr: [],
      //空格弹窗当前页面数据
      spaceDialogNum: 0,
      //空格弹窗当前页面id
      spaceDialogId: [],
      //空格弹窗图片地址
      spaceSrc: "",
      //空格弹窗数据存储对象
      spaceObjData: {},
      //图片弹窗信息
      spaceImgInfo: {},
      //标签数据
      labelArr: [],
      //切换数据
      changing: 1,
      //图片排版切换
      changingImg: false,
      //标签搜索弹窗数据
      searchLabelDialog: false,
      // 默认选中
      radio: ["1"],
      radioNum: ["1"],
      //右键弹窗数据
      rightLabelDialog: false,
      //弹出层
      operation: false,
      radio1: [""],
      operationArr: [],
      //当前页面状态
      process: "",
      type: 3,
      //图片左下弹窗显示状态
      visible: false,
      //搜索弹窗组件
      searchFor: false,
      //查看次数
      review: null,
      //收藏次数
      favorite: null,
      //排序数据
      sort: null,
      belongShow: null, //属于显示
      deleteVisible: false,
      loading: false,
      //空格弹窗图片数据（v之后）
      spaceWidth: "",
      spaceHeight: "",
      //空格弹窗图片数据（v之前）
      frontSpaceWidth: "",
      frontSpaceHeight: "",
      mousemoveId: "",
      selectAllText: "全选",
      selectAllBgColor: "",
    };
  },
  created() {
    var arr = JSON.parse(JSON.stringify(this.$store.getters.menuList)).splice(0, 2);
    arr[0].selectArr = [`${arr[0].id}_${this.$store.getters.PSprocess}`];
    arr[1].selectArr = [`${arr[1].id}_${this.type}`];
    this.operationArr = arr;
    // PSImgApi({type:this.type,process:this.$store.getters.process}).then(res=>{
    //     this.imgArr = res.data.data;
    //         this.total = res.data.total
    //         this.paginationInput = res.data.limit
    //         this.changing = 1
    //         this.sort = res.data.sort
    //     })

    //     return

    // this.operationArr[0].selectArr[0].slice(-1)
    let PS_Sky = JSON.parse(sessionStorage.getItem("PS_Sky"));
    if (PS_Sky) {
      this.authorInput = PS_Sky.select.author;
      (this.value2 = PS_Sky.select.time), (this.checkInput = PS_Sky.select.checkInput);
      this.radio = PS_Sky.select.radio;
      this.frontOrderInput = PS_Sky.select.source_id;
      this.sort = PS_Sky.select.sort;
      switch (PS_Sky.select.sort) {
        case "8":
          this.sortName = "点击查看次数最多";
          break;
        case "9":
          this.sortName = "收藏最多";
          break;
        case "1":
          this.sortName = "上传时间-升序";

          break;
        case "2":
          this.sortName = "上传时间-降序";

          break;
        case "3":
          this.sortName = "文件大小-升序";

          break;
        case "4":
          this.sortName = "文件大小-降序";

          break;
        case "5":
          this.sortName = "文件尺寸-升序";

          break;
        case "6":
          this.sortName = "文件尺寸-降序";

          break;
        case "7":
          this.sortName = "下载次数最多";

          break;
      }
      PSImgApi({
        type: this.type,
        process: this.$store.getters.PSprocess,
        is_tag: PS_Sky.select.is_tag,
        not_tag: PS_Sky.select.not_tag,
        author: PS_Sky.select.author,
        time: PS_Sky.select.time,
        tag_type: PS_Sky.select.radio[0],
        tag_id: PS_Sky.select.labelId,
        source_id: PS_Sky.select.source_id,
      }).then((res) => {
        if (res.code == 1000) {
          this.imgArr = res.data.data;
          this.total = res.data.total;
          this.paginationInput = res.data.limit;
          this.changing = res.data.show;
          this.sort = res.data.sort;
          if (PS_Sky.select.labelId) {
            this.labelId = PS_Sky.select.labelId;
            this.operateLabelInput = PS_Sky.select.operateLabelInput;
            var id = this.imgArr.map((res) => {
              return res.source_id;
            });
            singPSleLabelApi({
              is_tag: PS_Sky.select.is_tag,
              not_tag: PS_Sky.select.not_tag,
              source_id: PS_Sky.select.source_id,
              author: PS_Sky.select.author,
              time: PS_Sky.select.time,
              tag_id: PS_Sky.select.labelId,
              type: this.type,
              process: this.$store.getters.PSprocess,
              source_ids: id,
            }).then((val) => {
              if (val.code == 1000) {
                this.operateNum = val.data;
                this.operateNum.show = true;
                let arr = [];
                this.imgArr.map((v) => {
                  val.data.refers.map((l) => {
                    if (v.source_id == l.source_id) {
                      v.status = l.status;
                      arr.push(v);
                    }
                  });
                });
                this.imgArr = arr;
              }
            });
          }
        }
      });
    } else {
      PSImgApi({
        type: this.type,
        process: this.$store.getters.PSprocess,
      }).then((res) => {
        if (res.code == 1000) {
          this.imgArr = res.data.data;
          this.total = res.data.total;
          this.paginationInput = res.data.limit;
          this.changing = res.data.show;
          this.sort = res.data.sort;
        }
      });
    }
    //监听鼠标按下抬起事件
    window.addEventListener("keydown", this.handKeyCode, true);
    window.addEventListener("keyup", this.handKeyEvt, true);
  },
  mounted() {
    //监听页面滚动条事件
    window.addEventListener("scroll", (e) => this.imgScrollEvt(e), true);
  },
  updated() {
    this.$nextTick(() => {
      new flexImages({
        selector: ".flex-images",
        rowHeight: 280,
      });
    });
  },
  beforeDestroy() {
    // 在组件生命周期结束的时候销毁
    window.removeEventListener("keydown", this.handKeyCode, false);
    window.removeEventListener("keyup", this.handKeyEvt, false);
  },
  computed: {
    coverShow() {
      return this.$store.getters.coverShow;
    },
    menu() {
      return this.$store.getters.PSprocess;
    },
  },
  watch: {
    coverShow(newV, oldV) {
      if (newV == false) {
        this.imgArr = this.imgArr.map((res) => {
          res.leftSelect = false;
          return res;
        });
      }
    },
    menu(newV, oldV) {
      PSImgApi({
        type: this.type,
        process: newV,
      }).then((res) => {
        this.selectAllText = "全选";
        this.selectArr.length = "0";
        this.selectAllBgColor = "#409EFF";

        this.imgArr = res.data.data;
        this.total = res.data.total;
        this.paginationInput = res.data.limit;
        this.changing = 1;
        this.sort = res.data.sort;
        var arr = JSON.parse(JSON.stringify(this.$store.getters.menuList)).splice(0, 2);
        arr[0].selectArr = [`${arr[0].id}_${newV}`];
        arr[1].selectArr = [`${arr[1].id}_${this.type}`];
        this.operationArr = arr;
      });
    },
  },
  methods: {
    //键盘抬起事件
    handKeyEvt(e) {
      e = e || window.event;
      if (e.keyCode == 16) {
        this.shift = false;
        this.shiftFirst = false;
      }
    },
    //按下键盘事件
    handKeyCode(e) {
      e = e || window.event;
      if (this.imgArr.filter((res) => res.select == true).length !== 0) {
        //空格空格事件
        if (e.keyCode == 32) {
          this.dialogVisible = true;
          e.preventDefault();
        }
        // 键盘左键事件
        if (e.keyCode == 37) {
          if (this.spaceDialogNum == 1) {
            return;
          }
          e.preventDefault();
          this.spaceDialogNum -= 2;
          this.spaceDialogEvt();
        }
        //键盘右键事件
        if (e.keyCode == 39) {
          if (this.spaceDialogNum == this.selectArr.length) {
            return;
          }
          e.preventDefault();
          this.spaceDialogEvt();
        }
        // 键盘1事件（标签操作后）
        if (e.keyCode == 49 || e.keyCode == 97) {
          this.fingerboard1Evt();
        }
        //键盘2事件（标签操作后）
        if (e.keyCode == 50 || e.keyCode == 98) {
          this.fingerboard2Evt();
        }
        //键盘Delete事件
        if (e.keyCode == 8 || e.keyCode == 46) {
          if (
            this.dialogVisible == true ||
            this.searchLabelDialog == true ||
            this.rightLabelDialog == true ||
            this.deleteVisible == true ||
            this.uploadVisible == true
          ) {
            e.preventDefault();
            return;
          }
          this.deleteVisible = true;
        }
      }
      //键盘I事件
      if (e.keyCode == 73) {
        if (this.changing >= 3) {
          this.changing = 1;
        } else {
          this.changing++;
        }
        this.changingEvt(this.changing);
      }
      //shift 事件
      if (e.keyCode == 16) {
        this.shift = true;
        this.shiftFirst = true;
      }
      //键盘0清除选择
      if (e.keyCode == 48 || e.keyCode == 96 || e.keyCode == 67) {
        if (
          this.dialogVisible == true ||
          this.searchLabelDialog == true ||
          this.rightLabelDialog == true ||
          this.deleteVisible == true ||
          this.uploadVisible == true
        ) {
          return;
        }
        this.imgArr = this.imgArr.map((res) => {
          res.select = false;
          return res;
        });
        this.selectArr = this.imgArr.filter((res) => res.select == true);
      }
      //键盘A事件（全选）
      if (e.keyCode == 65) {
        this.imgArr = this.imgArr.map((res) => {
          res.select = true;
          return res;
        });
        this.selectArr = this.imgArr.filter((res) => res.select == true);
        this.selectAllText = "取消全选";
        this.selectAllBgColor = "#909399";
      }
      //键盘v事件
      if (e.keyCode == 86) {
        if (this.dialogVisible == true) {
          this.changingImg = !this.changingImg;
          // this.$nextTick(() => {
          //     new flexImages({
          //         selector: ".spaceDialogImg1",
          //     });
          // });
        }
      }
      //Page Up 翻页
      if (e.keyCode == 34) {
        if (
          this.dialogVisible == true ||
          this.searchLabelDialog == true ||
          this.rightLabelDialog == true ||
          this.deleteVisible == true ||
          this.uploadVisible == true
        ) {
          e.preventDefault();
          return;
        }
        e.preventDefault();
        delay(() => {
          this.currentPage1++;
          PSImgApi({
            is_tag: this.checkInputIs_tag,
            not_tag: this.checkInputNot_tag,
            author: this.authorInput,
            time: this.value2,
            sort: this.sort,
            tag_type: this.radio[0],
            tag_id: this.labelId,
            frontOrder: this.frontOrderInput,
            behindOrder: this.behindOrderInput,
            limit: this.paginationInput,
            page: this.currentPage1,
            type: this.type,
            process: this.$store.getters.PSprocess,
          }).then((res) => {
            if (res.code == 1000) {
              this.imgArr = res.data.data;
              this.total = res.data.total;
              this.paginationInput = res.data.limit;
              this.changing = res.data.show;
              this.sort = res.data.sort;
            }
          });
        }, 300);
      }
      // Page Down向后分页
      if (e.keyCode == 33) {
        if (
          this.dialogVisible == true ||
          this.searchLabelDialog == true ||
          this.rightLabelDialog == true ||
          this.deleteVisible == true ||
          this.uploadVisible == true
        ) {
          e.preventDefault();
          return;
        }
        delay(() => {
          if (this.currentPage1 <= 1) {
            this.currentPage1 = 1;
          } else {
            this.currentPage1--;
          }
          PSImgApi({
            is_tag: this.checkInputIs_tag,
            not_tag: this.checkInputNot_tag,
            author: this.authorInput,
            time: this.value2,
            sort: this.sort,
            tag_type: this.radio[0],
            tag_id: this.labelId,
            frontOrder: this.frontOrderInput,
            behindOrder: this.behindOrderInput,
            limit: this.paginationInput,
            page: this.currentPage1,
            type: this.type,
            process: this.$store.getters.PSprocess,
          }).then((res) => {
            if (res.code == 1000) {
              this.imgArr = res.data.data;
              this.total = res.data.total;
              this.paginationInput = res.data.limit;
              this.changing = res.data.show;
              this.sort = res.data.sort;
            }
          });
        }, 300);
      }
      //键盘5事件  剩余全否
      if (e.keyCode == 53 || e.keyCode == 101) {
        this.allNoEvt();
      }
    },
    //滑动事件
    imgScrollEvt(e) {
      var e =
        document.documentElement.scrollTop ||
        window.pageYOffset ||
        e ||
        document.body.scrollTop;
      if (e.target._prevClass !== "el-main el-mian") {
        false;
      }
      var scrollTop = e.target.scrollTop;
      let scrollStep = scrollTop - this.oldScrollTop;
      this.oldScrollTop = scrollTop;
      if (scrollTop <= 0) {
        this.header = true;
        this.$store.dispatch("setShowHeader", this.header);
        return;
      }
      if (scrollStep == 0) {
        this.header = true;
        this.$store.dispatch("setShowHeader", this.header);
        return;
      }
      if (scrollStep < 0) {
        this.header = true;
        this.$store.dispatch("setShowHeader", this.header);
      } else {
        this.header = false;
        this.$store.dispatch("setShowHeader", this.header);
      }
    },
    //弹窗属于事件
    belongEvt() {
      this.fingerboard1Evt();
    },
    //弹窗不s属于事件
    noBelongEvt() {
      this.fingerboard2Evt();
    },
    //键盘1事件
    fingerboard1Evt() {
      const formData = new FormData();
      if (this.dialogVisible == true && this.operateNum.show == true) {
        this.belongShow = 0;

        this.spaceObjData[this.spaceDialogId[0]].label = this.spaceObjData[
          this.spaceDialogId[0]
        ].label.map((res) => {
          for (let key in res.children) {
            if (res.children[key].id == this.labelId) {
              res.children[key].status = 0;
            }
          }
          return res;
        });

        return;
      }
      if (this.operateNum.show == true) {
        this.getSourceId().map((res) => {
          formData.append("source_ids[]", res);
        });
        formData.append("is_tag", this.labelId);
        fingerboardNumApi(formData).then((res) => {
          if (res.code == 1000) {
            // this.loading = true
            var id = this.imgArr.map((res) => {
              return res.source_id;
            });
            singPSleLabelApi({
              tag_id: this.labelId,
              type: this.type,
              process: this.$store.getters.PSprocess,
              source_ids: id,
            }).then((val) => {
              if (val.code == 1000) {
                this.operateNum = val.data;
                this.operateNum.show = true;
                let arr = [];
                this.imgArr.map((v) => {
                  val.data.refers.map((l) => {
                    if (v.source_id == l.source_id) {
                      v.status = l.status;
                      arr.push(v);
                    }
                  });
                });
                this.imgArr = arr;
                // this.loading = false
              }
            });
            this.belongShow = true;
          }
        });
      }
    },
    //键盘2事件
    fingerboard2Evt() {
      if (this.labelAjax == true) {
        return;
      }
      const formData = new FormData();
      if (this.operateNum.show == true && this.dialogVisible == true) {
        this.belongShow = 1;
        this.spaceObjData[this.spaceDialogId[0]].label = this.spaceObjData[
          this.spaceDialogId[0]
        ].label.map((res) => {
          for (let key in res.children) {
            if (res.children[key].id == this.labelId) {
              res.children[key].status = 1;
            }
          }
          return res;
        });
        return;
      }
      if (this.operateNum.show == true) {
        this.getSourceId().map((res) => {
          formData.append("source_ids[]", res);
        });
        formData.append("not_tag", this.labelId);
        fingerboardNumApi(formData).then((res) => {
          if (res.code == 1000) {
            // this.loading = true
            var id = this.imgArr.map((res) => {
              return res.source_id;
            });
            singPSleLabelApi({
              tag_id: this.labelId,
              type: this.type,
              process: this.$store.getters.PSprocess,
              source_ids: id,
            }).then((val) => {
              if (val.code == 1000) {
                this.operateNum = val.data;
                this.operateNum.show = true;
                let arr = [];
                this.imgArr.map((v) => {
                  val.data.refers.map((l) => {
                    if (v.source_id == l.source_id) {
                      v.status = l.status;
                      arr.push(v);
                    }
                  });
                });
                this.imgArr = arr;
                // this.loading = false
              }
            });
            this.belongShow = false;
          }
        });
      }
    },
    //图片点击事件
    imgEvt(e) {
      if (this.selectArr.length >= 1 && this.shift === true) {
        let start,
          end = "";
        for (var i = 0; this.imgArr.length > i; i++) {
          if (this.imgArr[i].source_id === e.source_id) {
            start = i;
          }
          if (
            this.imgArr[i].source_id !== e.source_id &&
            this.imgArr[i].select === true
          ) {
            end = i;
          }
        }
        if (start || (start == 0 && end)) {
          if (start > end) {
            let temp = "";
            temp = end;
            end = start;
            start = temp;
          } else {
            start++;
          }
          for (var i = 0; this.imgArr.length > i; i++) {
            if (i >= start && i < end) {
              this.imgArr[i].select = true;
            }
          }
        }
      }
      this.imgArr = this.imgArr.map((res) => {
        if (res.source_id == e.source_id) {
          if (res.select) {
            res.select = "";
          } else {
            res.select = true;
          }
        }
        return res;
      });
      this.selectArr = this.imgArr.filter((res) => res.select == true);
    },
    //排序
    sortEvt(res) {
      this.sort = res;
      switch (res) {
        case "8":
          this.sortName = "点击查看次数最多";
          this.review = 8;
          break;
        case "9":
          this.sortName = "收藏最多";
          this.favorite = 9;
          break;
        case "1":
          this.sortName = "上传时间-升序";
          this.review = null;
          this.favorite = null;
          break;
        case "2":
          this.sortName = "上传时间-降序";
          this.review = null;
          this.favorite = null;
          break;
        case "3":
          this.sortName = "文件大小-升序";
          this.review = null;
          this.favorite = null;
          break;
        case "4":
          this.sortName = "文件大小-降序";
          this.review = null;
          this.favorite = null;
          break;
        case "5":
          this.sortName = "文件尺寸-升序";
          this.review = null;
          this.favorite = null;
          break;
        case "6":
          this.sortName = "文件尺寸-降序";
          this.review = null;
          this.favorite = null;
          break;
        case "7":
          this.sortName = "下载次数最多";
          this.review = null;
          this.favorite = null;
          break;
      }
      PSImgApi({
        sort: res,
        tag_type: this.radio[0],
        tag_id: this.labelId,
        is_tag: this.checkInputIs_tag,
        not_tag: this.checkInputNot_tag,
        author: this.authorInput,
        time: this.value2,
        frontOrder: this.frontOrderInput,
        behindOrder: this.behindOrderInput,
        limit: this.paginationInput,
        type: this.type,
        process: this.$store.getters.PSprocess,
      }).then((res) => {
        if (res.code == 1000) {
          this.imgArr = res.data.data;
          this.total = res.data.total;
          this.paginationInput = res.data.limit;
          this.changing = res.data.show;
          this.sort = res.data.sort;
        }
      });
      this.setSessStorage();
    },
    //分页
    handleCurrentChange(e) {
      PSImgApi({
        tag_type: this.radio[0],
        tag_id: this.labelId,
        is_tag: this.checkInputIs_tag,
        not_tag: this.checkInputNot_tag,
        author: this.authorInput,
        time: this.value2,
        sort: this.sort,
        frontOrder: this.frontOrderInput,
        behindOrder: this.behindOrderInput,
        limit: this.paginationInput,
        page: e,
        type: this.type,
        process: this.$store.getters.PSprocess,
      }).then((res) => {
        if (res.code == 1000) {
          this.imgArr = res.data.data;
          this.total = res.data.total;
          this.paginationInput = res.data.limit;
          this.changing = res.data.show;
          this.sort = res.data.sort;
        }
      });
    },
    //分页输入框
    limitEvt(e) {
      PSImgApi({
        tag_type: this.radio[0],
        tag_id: this.labelId,
        is_tag: this.checkInputIs_tag,
        not_tag: this.checkInputNot_tag,
        author: this.authorInput,
        time: this.value2,
        sort: this.sort,
        frontOrder: this.frontOrderInput,
        behindOrder: this.behindOrderInput,
        limit: e,
        type: this.type,
        process: this.$store.getters.PSprocess,
      }).then((res) => {
        if (res.code == 1000) {
          this.imgArr = res.data.data;
          this.total = res.data.total;
          this.paginationInput = res.data.limit;
          this.changing = res.data.show;
          this.sort = res.data.sort;
        }
      });
    },
    //标签查询获取焦点
    searchLabelEvt() {
      this.searchLabelDialog = true;
    },
    searchLabel1Evt() {
      this.searchFor = true;
    },
    //
    mousemoveEvt(res) {
      this.mousemoveId = res.source_id;
    },
    mouseoutEvt() {
      this.mousemoveId = "";
    },
    //空格弹窗打开
    spaceDialogEvt() {
      if (this.spaceDialogNum < 0) {
        this.spaceDialogNum = 0;
      }
      let arrID = this.selectArr.map((res) => {
        return res.source_id;
      });
      let determine = false;
      this.spaceDialogId = [];
      this.spaceDialogId.push(arrID[this.spaceDialogNum]);

      this.spaceSrc = this.selectArr[this.spaceDialogNum].big_img;
      this.spaceDialogNum++;
      if (JSON.stringify(this.spaceObjData) !== "{}") {
        for (let key in this.spaceObjData) {
          if (key == this.spaceDialogId[0]) {
            this.spaceImgInfo = this.spaceObjData[key].info;
            this.spaceWidth = this.spaceObjData[key].w;
            this.spaceHeight = this.spaceObjData[key].h;
            this.spaceLabelArr = this.spaceObjData[key].label;
            this.spaceLabelArr.map((a) => {
              for (const key in a.children) {
                if (a.children[key].title == this.operateLabelInput) {
                  if (a.children[key].status == 0) {
                    this.belongShow = 0;
                  } else if (a.children[key].status == 1) {
                    this.belongShow = 1;
                  } else if (a.children[key].status == 3) {
                    this.belongShow = 3;
                  }
                }
              }
            });
            if (!this.spaceObjData[this.spaceDialogId[0]].front) {
              this.frontSpaceWidth = "auto";
              this.frontSpaceHeight = "850px";
            } else {
              this.frontSpaceWidth = "550px";
              this.frontSpaceHeight = "auto";
            }
            determine = true;
          }
        }
      }
      if (determine == true) {
        determine = false;
        return;
      }
      const formData = new FormData();
      formData.append("source_ids[]", this.spaceDialogId);
      formData.append("process", this.process);
      getPSImgLabelApi(formData).then((res) => {
        if (res.code == 1000) {
          let imginfo = {
            id: this.spaceDialogId[0],
            author: res.data.author,
            create_time: res.data.create_time,
            w: res.data.width,
            h: res.data.height,
          };
          this.spaceLabelArr = res.data.tag;
          this.spaceImgInfo = imginfo;

          this.spaceLabelArr = this.spaceLabelArr.map((a) => {
            for (const key in a.children) {
              if (a.children[key].title == this.operateLabelInput) {
                if (a.children[key].status == 0) {
                  this.belongShow = 0;
                } else if (a.children[key].status == 1) {
                  this.belongShow = 1;
                } else if (a.children[key].status == 3) {
                  this.belongShow = 3;
                }
              }
            }
            return a;
          });
          this.spaceObjData[this.spaceDialogId[0]] = {};
          this.spaceObjData[this.spaceDialogId[0]].label = this.spaceLabelArr;
          this.spaceObjData[this.spaceDialogId[0]].info = {
            ...imginfo,
          };
          let num = this.spaceImgInfo.w / this.spaceImgInfo.h;
          if (res.data.height - 0 > res.data.width - 0) {
            this.spaceObjData[this.spaceDialogId[0]].front = true;
            this.frontSpaceWidth = "auto";
            // this.frontSpaceHeight = "850px";
            this.frontSpaceHeight = "100%";
          } else {
            this.spaceObjData[this.spaceDialogId[0]].front = false;
            // this.frontSpaceWidth = "550px";
            this.frontSpaceWidth = "100%";
            this.frontSpaceHeight = "auto";
          }
          if (parseInt(num) == 3) {
            this.spaceObjData[this.spaceDialogId[0]].w = "auto";
            this.spaceWidth = "auto";
            this.spaceHeight = "500px";
            this.spaceObjData[this.spaceDialogId[0]].h = "500px";
          } else if (parseInt(num) == 4) {
            this.spaceObjData[this.spaceDialogId[0]].w = "auto";
            this.spaceWidth = "auto";
            this.spaceHeight = "400px";
            this.spaceObjData[this.spaceDialogId[0]].h = "400px";
          } else if (parseInt(num) == 5) {
            this.spaceObjData[this.spaceDialogId[0]].w = "auto";
            this.spaceWidth = "auto";
            this.spaceHeight = "317px";
            this.spaceObjData[this.spaceDialogId[0]].h = "300px";
          } else {
            this.spaceWidth = "auto";
            // this.spaceHeight = "850px";
            this.spaceHeight = "100%";
            this.spaceObjData[this.spaceDialogId[0]].w = "auto";
            // this.spaceObjData[this.spaceDialogId[0]].h = "850px";
            this.spaceObjData[this.spaceDialogId[0]].h = "100%";
          }
        }
      });
    },
    //空格弹窗全部否
    allNoEvt() {
      this.spaceLabelArr = this.spaceLabelArr.map((res) => {
        for (const key in res.children) {
          if (res.children[key].status == 3) {
            res.children[key].status = 1;
          }
        }
        return res;
      });
    },
    //图片切换
    arrowLeftEvt() {
      if (this.spaceDialogNum == 1) {
        return;
      }
      this.spaceDialogNum -= 2;
      this.spaceDialogEvt();
    },
    //图片切换
    arrowRightEvt() {
      if (this.spaceDialogNum == this.selectArr.length) {
        return;
      }
      this.spaceDialogEvt();
    },

    //空格弹窗切换
    changingImgEvt() {
      this.changingImg = !this.changingImg;
    },
    // 获取已选中图片的source_id
    getSourceId() {
      var source_ids = this.selectArr.map((res) => res.source_id);
      return source_ids;
    },
    //搜索弹窗打开
    searchDialogEvt() {
      if (this.labelArr.length !== 0) {
        return;
      }
      this.labelArr = [];
      getPSLabelApi({
        type: this.type,
        process: this.$store.getters.PSprocess,
      }).then((res) => (this.labelArr = res.data.tag));
    },
    //右键搜索弹窗打开
    rightDialogEvt() {
      const formData = new FormData();
      this.getSourceId().map((res) => {
        formData.append("source_ids[]", res);
      });
      getPSImgLabelApi(formData).then((res) => {
        if (res.code == 1000) {
          this.labelArr = res.data.tag;
        }
      });
    },
    //标签改变状态
    colorEvt(e) {
      this.labelArr = this.labelArr.map((val) => {
        if (val.one == true && e.parent_id == val.id) {
          for (let key in val.children) {
            if (e.id == val.children[key].id) {
              if (val.children[key].status == 1) {
                val.children[key].status = 3;
              } else if (val.children[key].status == 0) {
                val.children[key].status = 1;
              } else if (val.children[key].status == 3) {
                val.children[key].status = 0;
              }
            }
          }
        }
        return val;
      });
    },
    color1Evt(e) {
      this.spaceLabelArr = this.spaceLabelArr.map((val) => {
        if (val.one == true && e.parent_id == val.id) {
          for (let key in val.children) {
            if (e.id == val.children[key].id) {
              if (val.children[key].status == 1) {
                val.children[key].status = 3;
              } else if (val.children[key].status == 0) {
                val.children[key].status = 1;
              } else if (val.children[key].status == 3) {
                val.children[key].status = 0;
              }
            }
          }
        }
        return val;
      });
    },
    //标签事件（搜索弹窗）
    searchLabEvt(e) {
      this.labelArr = this.labelArr.map((val) => {
        if (val.one == true && e.parent_id == val.id) {
          for (let key in val.children) {
            val.children[key].status = 1;
            if (e.id == val.children[key].id) {
              val.children[key].status = 0;
            }
          }
          return val;
        }
        for (let key in val.children) {
          if (e.id == val.children[key].id) {
            if (val.children[key] !== null) {
              if (val.children[key].status == 3 || val.children[key].status == 2) {
                val.children[key].status = 0;
              } else if (val.children[key].status == 0) {
                val.children[key].status = 1;
              } else if (val.children[key].status == 1) {
                val.children[key].status = 3;
              }
            }
          }
        }
        return val;
      });
    },
    //点击标签（标签操作）
    labelSearchEvt(e) {
      let id = this.imgArr.map((res) => {
        return res.source_id;
      });
      this.labelArr = this.labelArr.map((val) => {
        if (val.one == true && e.parent_id == val.id) {
          this.labelAjax = true;
        } else {
          this.labelAjax = false;
        }
        for (let key in val.children) {
          val.children[key].status = 3;
          if (e.id == val.children[key].id) {
            val.children[key].status = 1;
            singPSleLabelApi({
              is_tag: this.checkInputIs_tag,
              not_tag: this.checkInputNot_tag,
              author: this.authorInput,
              time: this.value2,
              source_id: this.frontOrderInput,
              tag_id: val.children[key].id,
              type: this.type,
              process: this.$store.getters.PSprocess,
              source_ids: id,
            }).then((res) => {
              if (res.code == 1000) {
                this.operateNum = res.data;
                this.operateNum.show = true;
                let arr = [];
                this.imgArr.map((v) => {
                  res.data.refers.map((l) => {
                    if (v.source_id == l.source_id) {
                      v.status = l.status;
                      arr.push(v);
                    }
                  });
                });
                this.imgArr = arr;
              }
            });
            setTimeout(() => {
              this.searchLabelDialog = false;
              this.operateLabelInput = e.title;
              this.labelId = e.id;
              this.radio = ["1"];
              this.setSessStorage();
            }, 500);
          }
        }
        return val;
      });
    },
    //确认关闭右键弹窗
    submitRightLabelEvt() {
      //绿色标签
      let is_tag = [];
      //红色标签
      let not_tag = [];
      let other_tag = [];
      let hui_tag = [];
      this.labelArr.map((res) => {
        for (let key in res.children) {
          if (res.children[key].status == 0) {
            is_tag.push(res.children[key].id);
          }
          if (res.children[key].status == 1) {
            not_tag.push(res.children[key].id);
          }
          if (res.children[key].status == 2) {
            other_tag.push(res.children[key].id);
          }
          if (res.children[key].status == 3) {
            hui_tag.push(res.children[key].id);
          }
        }
      });
      rightPsLabelApi({
        source_ids: this.getSourceId(),
        is_tag,
        not_tag,
        other_tag,
      }).then((res) => {
        if (res.code == 1000) {
          if (this.operateNum.show) {
            let id = this.getSourceId();
            let arr = is_tag.filter((res) => res == this.labelId);
            let arr1 = not_tag.filter((res) => res == this.labelId);
            let arr2 = hui_tag.filter((res) => res == this.labelId);
            if (arr.length !== 0) {
              this.imgArr = this.imgArr.map((res) => {
                id.map((val) => {
                  if (res.source_id == val) {
                    res.status = 0;
                  }
                });
                return res;
              });
            }
            if (arr1.length !== 0) {
              this.imgArr = this.imgArr.map((res) => {
                id.map((val) => {
                  if (res.source_id == val) {
                    res.status = 1;
                  }
                });
                return res;
              });
            }
            if (arr2.length !== 0) {
              this.imgArr = this.imgArr.map((res) => {
                id.map((val) => {
                  if (res.source_id == val) {
                    res.status = 3;
                  }
                });
                return res;
              });
            }
          }
          this.rightLabelDialog = false;
        }
      });
    },
    //确认关闭空格弹窗
    submitSpaceLabelEvt() {
      let data = {};
      for (let key in this.spaceObjData) {
        data[key] = {};
        data[key].is_tag = [];
        data[key].not_tag = [];
        data[key].hui_tag = [];

        this.spaceObjData[key].label.map((res) => {
          for (let v in res.children) {
            if (res.children[v].status == 0) {
              data[key].is_tag.push(res.children[v].id);
            }
            if (res.children[v].status == 1) {
              data[key].not_tag.push(res.children[v].id);
            }
            if (res.children[v].status == 3) {
              data[key].hui_tag.push(res.children[v].id);
            }
          }
        });
      }

      psLabelApi({
        data,
      }).then((res) => {
        if (res.code == 1000) {
          if (this.operateNum.show) {
            this.imgArr = this.imgArr.map((i) => {
              for (let v in data) {
                if (i.source_id == v) {
                  let arr = data[v].is_tag.filter((res) => res == this.labelId);
                  let arr1 = data[v].not_tag.filter((res) => res == this.labelId);
                  let arr2 = data[v].hui_tag.filter((res) => res == this.labelId);

                  if (arr.length !== 0) {
                    i.status = 0;
                  }
                  if (arr1.length !== 0) {
                    i.status = 1;
                  }
                  if (arr2.length !== 0) {
                    i.status = 3;
                  }
                }
              }
              return i;
            });
          }
          this.spaceObjData = {};
          this.$message({
            message: "更改成功",
            type: "success",
          });
          this.dialogVisible = false;
        }
      });
    },

    //空格空格弹窗关闭
    handleClose(done) {
      this.dialogVisible = false;
      this.spaceDialogNum = 0;
    },
    //关闭弹窗
    closeEvt() {
      this.labelArr = [];
    },
    //关闭空格弹窗
    cancellationEvt() {
      this.dialogVisible = false;
    },
    spaceCloseDiaEvt() {
      this.spaceObjData = {};
      this.spaceDialogNum = 0;
    },
    //切换标签
    labelEvt(res) {
      this.spaceLabelArr = this.spaceLabelArr.map((val) => {
        if (val.one == true && res.parent_id == val.id) {
          for (let key in val.children) {
            val.children[key].status = 1;
            if (res.id == val.children[key].id) {
              val.children[key].status = 0;
            }
          }
          return val;
        }
        for (let key in val.children) {
          if (res.id == val.children[key].id) {
            if (val.children[key] !== null) {
              if (val.children[key].status == 3 || val.children[key].status == 2) {
                val.children[key].status = 0;
              } else if (val.children[key].status == 0) {
                val.children[key].status = 1;
              } else if (val.children[key].status == 1) {
                val.children[key].status = 3;
              }
            }
          }
        }
        return val;
      });
      for (let key in this.spaceObjData) {
        if (key == this.spaceDialogId[0]) {
          this.spaceObjData[key].label = this.spaceLabelArr;
        }
      }
    },
    //切换排序方式
    changingEvt(num) {
      // show
      showApi({
        show: num,
      }).then((res) => {
        if (res.code == 1000) {
          this.changing = num;
        }
      });
    },
    //标签操作事件（头部）
    checkboxEvt(e) {
      this.loading = true;
      if (e.length == 0) {
        delay(() => {
          this.radio = this.radioNum;
          this.setSessStorage();
          this.selectImg();
        }, 300);
        return;
      }
      this.radio = [];
      if (e.length == 1) {
        this.radio.push(e[0]);
      } else {
        this.radio.push(e[1]);
      }
      delay(() => {
        this.radioNum = this.radio;
        this.setSessStorage();
        this.selectImg();
      }, 300);
    },
    //改变图片选项
    checkbox1Evt(e) {
      e.selectArr = e.selectArr.slice(-1);
    },
    //图片鼠标右键事件
    rightClickEvt() {
      if (this.selectArr.length != 0) {
        this.labelArr = [];
        this.rightLabelDialog = true;
      }
    },
    //出现改变弹窗
    leftSelectEvt(e) {
      this.showChangeImg(e, true);
    },
    //关改变弹窗闭
    cancelEvt(e) {
      this.showChangeImg(e, false);
    },
    //弹窗组件方法
    cancel(params) {
      this.searchFor = params;
    },
    revise(params) {
      this.imgArr = params.data;
      this.total = params.total;
      this.paginationInput = params.limit;
    },
    reviseText(params) {
      let str = "";
      this.checkInputIs_tag = params.filter((res) => res.status == 0);
      this.checkInputNot_tag = params.filter((res) => res.status == 1);
      this.checkInputIs_tag = this.checkInputIs_tag.map((res) => {
        return res.id;
      });
      this.checkInputNot_tag = this.checkInputNot_tag.map((res) => {
        return res.id;
      });
      params.map((res) => {
        str += `${res.title},`;
      });
      this.checkInput = str;
      this.setSessStorage();
    },
    //改变弹出方法
    showChangeImg(e, boolean) {
      this.imgArr = this.imgArr.map((res) => {
        if (res.source_id == e.source_id) {
          res.leftSelect = boolean;
        }
        return res;
      });
      this.$store.dispatch("setCoverShow", boolean);
    },
    //上传
    uploadEvt() {
      this.uploadVisible = true;
      // window.open('/upload')
      // this.$router.push('/upload')
    },
    //确认改变图片
    changeImgEvt(e) {
      var str = this.operationArr[0].selectArr[0].slice(-1);
      var str1 = this.operationArr[1].selectArr[0].slice(-1);
      var arr = this.selectArr.map((val) => {
        return val.source_id;
      });
      changePSImgApi({
        process: str,
        type: str1,
        source_ids: arr,
      }).then((res) => {
        if (res.code == 1000) {
          this.imgArr = this.imgArr.map((a) => {
            this.selectArr.map((val) => {
              if (a.source_id == val.source_id) {
                a = {};
              }
            });
            return a;
          });
          var arr = JSON.parse(JSON.stringify(this.$store.getters.menuList)).splice(0, 2);
          arr[0].selectArr = [`${arr[0].id}_${this.$store.getters.PSprocess}`];
          arr[1].selectArr = [`${arr[1].id}_${this.type}`];
          this.operationArr = arr;
          this.showChangeImg(e, false);
        }
      });
    },
    //选择作者（搜索）
    authorEvt() {
      this.setSessStorage();
      this.selectImg();
    },
    //选择时间（搜索）
    timeEvt(e) {
      this.setSessStorage();
      this.selectImg();
    },
    clearEvt1() {
      this.checkInputIs_tag = [];
      this.checkInputNot_tag = [];
      this.selectImg();
    },
    clearEvt2() {
      this.selectImg();
    },
    clearEvt3() {
      this.selectImg();
    },
    //查询
    selectImg() {
      PSImgApi({
        type: this.type,
        process: this.$store.getters.PSprocess,
        is_tag: this.checkInputIs_tag,
        not_tag: this.checkInputNot_tag,
        author: this.authorInput,
        time: this.value2,
        tag_type: this.radio[0],
        tag_id: this.labelId,
        source_id: this.frontOrderInput,
        behindOrder: this.behindOrderInput,
      }).then((res) => {
        if (res.code == 1000) {
          this.imgArr = res.data.data;
          this.total = res.data.total;
          this.paginationInput = res.data.limit;
          this.changing = res.data.show;
          this.sort = res.data.sort;
          this.loading = false;
        }
      });
    },
    //存储操作数据
    setSessStorage() {
      var PS_Sky = {};
      PS_Sky.select = {
        process: this.PSprocess,
        is_tag: this.checkInputIs_tag,
        not_tag: this.checkInputNot_tag,
        author: this.authorInput,
        time: this.value2,
        checkInput: this.checkInput,
        source_id: this.frontOrderInput,
        operateLabelInput: this.operateLabelInput,
        radio: this.radio,
        checkInput: this.checkInput,
        labelId: this.labelId,
        sort: this.sort,
      };
      sessionStorage.setItem("PS_Sky", JSON.stringify(PS_Sky));
    },
    //id查询
    frontOrderEvt() {
      this.setSessStorage();
      this.selectImg();
    },

    //清除搜索条件
    cleanUpEvt() {
      this.checkInput = "";
      this.behindOrderInput = "";
      this.frontOrderInput = "";
      this.value2 = "";
      this.authorInput = "";
      this.labelId = "";
      this.labelArr = [];
      this.checkInputIs_tag = [];
      this.checkInputNot_tag = [];
      this.operateLabelInput = "";
      this.operateNum.show = false;
      this.selectArr = [];
      this.sortName = "排序方式";
      this.sort = null;
      this.selectAllText = "全选";
      this.selectAllBgColor = "#409EFF";
      (this.currentPage1 = 1),
        delay(() => {
          sessionStorage.removeItem("PS_Sky");
          PSImgApi({
            process: this.$store.getters.PSprocess,
            type: this.type,
            all: "all",
          }).then((res) => {
            if (res.code == 1000) {
              this.imgArr = res.data.data;
              this.total = res.data.total;
              this.paginationInput = res.data.limit;
            }
          });
        }, 300);
    },
    //本页全选
    selectAllEvt() {
      if (this.selectArr.length === this.imgArr.length) {
        this.imgArr = this.imgArr.map((res) => {
          res.select = false;
          return res;
        });
        this.selectArr = [];
        this.selectAllText = "全选";
        this.selectAllBgColor = "#409EFF";
      } else {
        this.imgArr = this.imgArr.map((res) => {
          res.select = true;
          return res;
        });
        this.selectArr = this.imgArr.filter((res) => res.select == true);
        this.selectAllText = "取消全选";
        this.selectAllBgColor = "#909399";
      }
    },
    //点击删除  出现弹窗
    delete_Pop() {
      if (this.selectArr.length > 0) {
        this.deleteVisible = true;
      }
    },
    //删除已选中
    deleteEvt() {
      var arr = this.selectArr.map((val) => {
        return val.source_id;
      });
      if (this.$store.getters.PSprocess == 4) {
        deleteApi({
          source_ids: arr,
        }).then((res) => {
          if (res.code == 1000) {
            this.imgArr = this.imgArr.map((a) => {
              this.selectArr.map((val) => {
                if (a.source_id == val.source_id) {
                  a = {};
                }
              });
              return a;
            });
            this.deleteVisible = false;
          }
        });
      } else {
        changePSImgApi({
          type: this.type,
          process: 4,
          source_ids: arr,
        }).then((res) => {
          if (res.code == 1000) {
            this.imgArr = this.imgArr.map((a) => {
              this.selectArr.map((val) => {
                if (a.source_id == val.source_id) {
                  a = {};
                }
              });
              return a;
            });
            this.deleteVisible = false;
            this.selectArr.length = "0";
          }
        });
      }
    },
  },
};
</script>

<style  lang="less"  scoped>
@import url("../../../backHome/js/flex-images.css");
@import url("../../../style/space.less");

.cover_box {
  position: fixed;
  z-index: 452;
  top: 0;
  width: 100vw;
  height: 100vh;
  background-color: rgb(95, 94, 94, 0.4);
}

.search-box {
  width: calc(100% - 190px);
  min-width: 1200px;
  height: 90px;
  background: #fff;
  position: fixed;
  top: 60px;
  z-index: 1;
  /* visibility: inherit; */
  /*box-shadow: 0px 10px 10px 1px rgba(226, 226, 226, 0.4);*/
  /* transition: all 0.8s ease .5s; */
  /* transition: all .5s ease .7s; */
  transition: all 0.7s ease-in-out 0.7s;
  transform: translateZ(0);
}

/*
    .slide {
        transition: all .2s ease .2s;
    } */

.search-box1 {
  /* height: 0;
        visibility: hidden; */
  transition: all 0.3s ease-in-out 0.3s;
  transform: translate3d(0, -100%, 0);
  opacity: 0;
}

.caoz {
  margin-top: 8px;
  display: flex;
}

.img-box {
  margin-top: 90px;
  background: #fff;
}

.img-box .item {
  position: relative;
  display: flex !important;
  justify-content: center;
}

.img-box .item img {
  object-fit: cover;
  width: 100%;
}

.img-box .item img:hover {
  /* transition: all .5s linear 0s;
        transform: scale(1.2);*/
}

.img-box .bottom_text {
  position: absolute;
  width: 100%;
  height: 20px;
  bottom: 0;
  font-size: 12px;
  color: #fff;
  display: flex;
  justify-content: space-between;
}

.img-box .bottom_text div {
  margin: 0 20px;
}

.id_text {
  position: absolute;
  top: 5px;
  left: 10px;
  color: #fff;
  font-size: 12px;
}

.bottom_text b {
  position: absolute;
  display: block;
  bottom: 6px;
  right: 5px;
  width: 14px;
  height: 14px;
  border: 1px solid #fff;
  border-radius: 50%;
}

.bottom_text i {
  display: block;
  position: absolute;
  height: 10px;
  width: 10px;
  bottom: 8px;
  right: 7px;
  border-radius: 50%;
}

.spaceDialog_box {
  width: 100%;
  display: flex;
  justify-content: flex-start;
  flex-direction: row;
}

.spaceDialog_box .check div {
  width: 90px;
}

.spaceDialog_box .check {
  margin-top: 30px;
}

/* .spaceDialogImg {
        width: 555px;
        height: 850px;
        min-width: 550px;
        display: flex;
        min-height: 400px;
        justify-content: center;
        align-items: center;
        margin-right: 20px;
        border-right: 1px solid #eee;
        background-color: rgb(200, 200, 200, 0.2);
        position: relative;
        overflow: hidden;
    }

    .spaceDialogImg1 {
        width: 100%;
        height: 850px;
        min-width: 1080px;
        min-height: 400px;
        background-color: rgb(200, 200, 200, 0.2);
        position: relative;
        display: flex;
        justify-content: center;
        align-items: center;
        overflow: hidden;
    } */

.spaceDialogImg img {
  object-fit: cover;
}

.spaceDialogImg1 img {
  object-fit: cover;
}

.info_box {
  position: absolute;
  bottom: 10px;
  left: 10px;
}

.info_box span {
  padding: 0 5px;
}

.belong_box {
  position: absolute;
  bottom: 10px;
  right: 250px;
  display: flex;
  justify-content: space-around;
}

.belong_box span {
  padding: 0 30px;
  position: relative;
  cursor: pointer;
}

.belong_box span b {
  font-size: 14px;
  font-weight: 400;
  color: #c02cac;
}

.belong_box span i {
  display: block;
  width: 12px;
  height: 12px;
  float: left;
  border-radius: 50%;
  border: 1px solid #999;
  margin-right: 5px;
  margin-top: 2px;
  z-index: 12;
}

.belong_box span strong {
  position: absolute;
  display: block;
  top: 4px;
  left: 32px;
  width: 8px;
  height: 8px;
  border-radius: 50%;
}

.allNo_box {
  position: absolute;
  bottom: 50px;
  right: 20px;
  font-size: 12px;
}

.allNo_box button {
  background-color: #fff;
  color: #c02cac;
  border: 1px solid #e1e1e1;
  padding: 5px 10px;
  cursor: pointer;
}

.changing_box {
  width: 60px;
  height: 20px;
  position: absolute;
  z-index: 1;
  top: 5px;
  left: 5px;
  text-align: center;
  cursor: pointer;
}

.all-box {
  float: left;
  font-size: 12px;
  color: #6a6a6a;
  margin-top: 8px;
}

.select {
  position: absolute;
  top: -25px;
  right: -25px;
  width: 0;
  height: 0;
  border: 25px solid;
  border-color: transparent #409eff transparent transparent;
  transform: rotate(135deg);
  color: #fff;
}

.el-icon-check {
  position: absolute;
  font-size: 18px;
  top: -9px;
  left: 5px;
  transform: rotate(-133deg);
}

.block {
  position: fixed;
  right: 1%;
  top: 10px;
  /* transition: all .2s ease .2s; */
}

.block1 {
  visibility: hidden;
}

.block1 > div {
  display: none;
}

.changing-box {
  position: absolute;
  top: 37px;
  right: 1%;
}

.spaceLabel_box {
  max-width: 1100px;
  min-width: 600px;
  overflow-y: hidden;
  position: relative;
  transition: all 0.5s ease 0.2s;
}

.spaceLabel_box1 {
  height: 0;
  visibility: hidden;
  display: none;
}

.check {
  display: flex;
}

.check div {
  width: 100px;
}

.check div p {
  margin: 0;
  font-size: 14px;
  margin-bottom: 25px;
  padding-left: 14px;
}

.check div .checkbox {
  width: 100%;
  margin-top: 15px;
  position: relative;
  cursor: pointer;
  -webkit-touch-callout: none;
  /*系统默认菜单被禁用*/
  -webkit-user-select: none;
  /*webkit浏览器*/
  -khtml-user-select: none;
  /*早期浏览器*/
  -moz-user-select: none;
  /*火狐*/
  -ms-user-select: none;
  /*IE10*/
  user-select: none;
}

.check div .checkbox i {
  display: block;
  width: 12px;
  height: 12px;
  float: left;
  border-radius: 50%;
  border: 1px solid #999;
  margin-right: 5px;
  margin-top: 2px;
  z-index: 12;
}

.check div .checkbox b {
  display: block;
  width: 8px;
  height: 8px;
  position: absolute;
  top: 4px;
  left: 2px;
  border-radius: 50%;
}

.num-box {
  position: absolute;
  bottom: 10px;
  right: 48%;
  font-size: 12px;
}

.el-dropdown {
  margin: 0 15px;
  font-size: 12px;
}

.operation_box {
  position: absolute;
  bottom: 17px;
  left: 15px;
  color: #fff;
  cursor: pointer;
}

.operation_box button {
  padding: 0;
  font-size: 18px;
  color: #409eff;
  background: rgba(248, 248, 248, 0);
}

.operation_center {
  display: flex;
  position: relative;
  height: 300px;
  margin-top: 10px;
}

.center_box span {
  padding-left: 33px;
  font-size: 13px;
}

.center_box .el-checkbox {
  margin-top: 15px;
}

.all_text {
  background-color: #409eff;
  font-size: 13px;
  color: #fff;
  cursor: pointer;
  padding: 5px 20px;
  border-radius: 3px;
}

.arrow_box {
  position: absolute;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: space-between;
}

.arrow_box div {
  width: 10%;
  height: 100%;
}

.arrow_box .left:hover {
  cursor: url("../../../backHome/components/cur/left.png"), auto;
}

.arrow_box .right:hover {
  cursor: url("../../../backHome/components/cur/right.png"), auto;
}

.rightSearch {
  position: absolute;
  bottom: 25px;
  left: 33px;
}

.space_title:hover {
  background-color: rgb(154, 46, 46) !important;
  color: #fff;
}

.pagination_box {
  min-width: 500px;
  display: flex;
  align-items: center;
  justify-content: flex-end;
}

/deep/ .center_box .el-checkbox .el-checkbox__label {
  color: #a1a1a1;
}

.operation_center .btn_box {
  position: absolute;
  bottom: 10px;
  right: 10px;
}

/deep/ .searchLabel {
  min-width: 1250px;
  min-height: 590px;
}

/deep/ .spaceDialog {
  /*max-width: 1730px;*/
  min-width: 1200px;
  transform: translateY(-80px);
}

@media screen and (min-width: 2500px) {
  .check div p {
    font-size: 15px !important;
  }

  .checkbox {
    font-size: 14px !important;
  }
}

/deep/ .el-loading-mask {
  height: 100vh;
}

/deep/ .el-pager .number {
  font-size: 12px;
  color: #6a6a6a;
}

/deep/ .el-pager li.active {
  color: #409eff;
}

button {
  border: none;
}

/deep/ .el-range-separator {
  width: 13%;
  padding: 0;
}

/deep/ .el-dialog__body {
  font-size: 12px;
}

/deep/ .spaceDialog .el-dialog__body {
  padding: 0 10px;
  min-height: 600px;
}

/deep/ .spaceDialog .el-dialog__header {
  padding: 5px 0;
}

/deep/ .spaceDialog .el-dialog__footer {
  padding: 10px 20px 5px;
}

/deep/ .el-dropdown-menu__item {
  font-size: 12px;
}

.el-checkbox-group {
  margin-left: 10px;
  font-size: 12px;
}

/deep/ .el-time-panel.el-popper {
  display: none;
}

/deep/ .el-checkbox__label {
  font-size: 12px;
  font-family: Avenir, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto,
    "Helvetica Neue", Arial, "Noto Sans", sans-serif, "Apple Color Emoji",
    "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji", sans-serif;
  font-weight: 400;
}

/deep/ .is-disabled .el-checkbox__inner {
  background-color: #409eff !important;
  border-color: #409eff !important;
}

/deep/ .is-disabled .el-checkbox__inner::after {
  border-color: #fff !important;
}

/deep/ .is-disabled span {
  color: #409eff !important;
  cursor: pointer !important;
}
</style>
<style>
.el-picker-panel__sidebar button:nth-child(4) {
  margin-bottom: 10px;
}

.el-picker-panel__shortcut {
  font-size: 12px !important;
}
</style>



// WEBPACK FOOTER //
// src/material/components/PS_Sky/index.vue